module.exports = __webpack_public_path__ + "images/android-app-store-badge.d04656d42d7653b0075bdfe754d7fe9b.svg";